import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatJson } from '../utils';

export const JsonAccordion = ({ title, value, defaultExpanded = false }) => (
  <Accordion defaultExpanded={defaultExpanded} className="wivi-json-accordion" variant="outlined" disableGutters>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="subtitle2" fontWeight={600}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Box component="pre" className="wivi-json-block">
        {formatJson(value)}
      </Box>
    </AccordionDetails>
  </Accordion>
);
